import { EntityPickerFieldSchema } from '../EntityPicker/schema.esm.js';

const OwnedEntityPickerFieldSchema = EntityPickerFieldSchema;
const OwnedEntityPickerSchema = OwnedEntityPickerFieldSchema.schema;

export { OwnedEntityPickerFieldSchema, OwnedEntityPickerSchema };
//# sourceMappingURL=schema.esm.js.map
